import { getUserSteamApiKey } from 'core/User/selectors';
import { shallowEqual, useSelector } from 'react-redux';

export const useGetApiKey = () => ({
  steamApiKey: useSelector(getUserSteamApiKey, shallowEqual),
});
